export enum Environment {
	PRODUCTION = 'prod',
	STAGING = 'staging',
	DEVELOPMENT = 'dev',
	LOCAL = 'local',
}
